import Head from 'next/head'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import ArticleSection from 'components/article/article-section/ArticleSection'
import styles from './EncyclopediaSubCategory.module.scss'
import Hero from 'features/encyclopedia/components/hero/Hero'
import EncyclopediaNav from 'features/encyclopedia/components/encyclopedia-nav/EncyclopediaNav'
import { EncyclopediaSubcategoryProps } from 'features/encyclopedia/sub-category/types'

const EncyclopediaSubCategory = ({ articles, subCategory }: EncyclopediaSubcategoryProps) => {
  // i18n
  const { t } = useTranslation(['encyclopedia'])

  // Next router
  const { asPath, locale } = useRouter()

  return (
    <>
      {/* SEO */}
      <Head>
        <link rel="canonical" href={`https://www.boltenergie.be/${locale}${asPath}`} />
      </Head>

      {/* BREADCRUMBS + SEARCH */}
      <EncyclopediaNav />

      {/* HERO */}
      <Hero category={subCategory.attributes.category.data} subCategory={subCategory.attributes.title} />

      {/* ARTICLES */}
      <ArticleSection title={t('article', 'Artikels')} articles={articles} className={styles.articles} />
    </>
  )
}

export default EncyclopediaSubCategory
